<template>
  <v-list
    dense
    two-line
  >
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title class="title">
          {{ $t('Subtotal') }}
          <span v-if="order.discountIncluded() && order.summary.total_items_discount.amount > 0">
            ({{ $t('includes discounts') }})
          </span>
        </v-list-tile-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-chip
          small
          color="primary"
          dark
        >
          {{ order.summary.total_items_amount | money }}
        </v-chip>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'OrderSingleSummarySubtotals',

  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
